import { type components } from '~/fecom-api/schema';
import { ProductDetailsStarRating } from './product-details-star-rating';

export function ProductUserReview({
  review,
}: {
  review: components['schemas']['ProductReview'];
}) {
  return (
    <div className="col-span-2 grid grid-cols-subgrid grid-rows-[auto,1fr] items-center gap-x-4 gap-y-4 border-b-2 border-b-border pb-4 last:border-b-0 last:pb-0">
      <p className="col-span-1 col-start-1 row-span-1 row-start-1 text-sm">
        {review.userFriendlyCreatedDate}
      </p>
      <div className="col-span-1 col-start-1 row-span-1 row-start-2 flex flex-col gap-4 self-start text-sm">
        <p className="text-base font-semibold">
          <span className="block max-w-[10rem] 2xl:max-w-none">
            {review.consumerName}
          </span>
        </p>
        <p className="flex items-center gap-1 text-sm text-muted-foreground">
          Verified purchase
        </p>
      </div>

      <div className="col-span-1 col-start-2 row-span-1 row-start-1 flex items-center gap-2">
        <ProductDetailsStarRating
          maxRating={5}
          variant="default"
          hideText
          rating={review.stars}
          starSizeOverride={18}
        />{' '}
        {review.stars} / 5
      </div>
      <div className="col-span-1 col-start-2 row-span-1 row-start-2 flex flex-col gap-4 self-stretch">
        <div className="text-base">{review.content}</div>
        <div className="mt-auto flex flex-col gap-4 lg:flex-row lg:gap-6">
          {review.attributeRatings
            .filter((attr) => typeof attr.rating === 'number')
            .map((attr) => (
              <div
                key={attr.attributeName}
                className="flex flex-row gap-2 sm:items-center"
              >
                <span className="font-semibold">{attr.attributeName}:</span>{' '}
                <div className="flex gap-2">{attr.rating} / 5</div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
}
